import React, { useState, useRef, useEffect, useCallback } from "react";
import Grid from "@mui/material/Grid";
import { CmpStatusIconV1 } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";

export const SummaryTblCard = ({ data = [], onClick = () => {} }) => {
  const [visibleData, setVisibleData] = useState([]);
  const observerRef = useRef(null);
  const lastElementRef = useRef(null);
  const BATCH_SIZE = 10; // Number of items to load per batch

  // Load initial batch
  useEffect(() => {
    if (data.length) {
      setVisibleData(data.slice(0, BATCH_SIZE));
    }
  }, [data]);

  // Function to load more items when last item is visible
  const loadMore = useCallback(() => {
    if (data.length > visibleData.length) {
      const nextItems = data.slice(0, visibleData.length + BATCH_SIZE);
      setVisibleData(nextItems);
    }
  }, [data, visibleData]);

  // Observe last element to trigger loading more data
  useEffect(() => {
    if (!lastElementRef.current) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      { rootMargin: "100px" } // Load when 100px away from the viewport
    );

    observerRef.current.observe(lastElementRef.current);
    return () => observerRef.current?.disconnect();
  }, [loadMore]);

  return (
    <Grid container spacing={1} className="mt-1">
      {visibleData.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          key={index}
          onClick={() => onClick({ row: item })}
          ref={index === visibleData.length - 1 ? lastElementRef : null} // Observe last item
        >
          <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }} className="CardBorderDesign">
            <Grid item xs={3} sm={3} md={3}>
              <Typography className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse">
              VocNo
              </Typography>
            </Grid>

            <Grid item xs={3} sm={3} md={3}>
              <Typography className="CardFontStyleValue CardFontStyle txt-overflow-ellipse">
                {item?.A_VocNo}
              </Typography>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse">
              Branch
              </Typography>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse">
                {item?.BrName}
              </Typography>
            </Grid>

            <Grid item xs={2} sm={2} textAlign={"end"}>
              <CmpStatusIconV1 xStatus={item?.Status} />
            </Grid>

            <Grid item xs={3} sm={2} md={3} lg={4}>
              <Typography className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse">
                Date
              </Typography>
            </Grid>

            <Grid item xs={3} sm={4} md={3} lg={3}>
              <Typography className="CardFontStyleValue CardFontStyle txt-overflow-ellipse">
                {moment(item?.A_PostDt).format("DD/MM/YYYY") || ""}
              </Typography>
            </Grid>

            <Grid item xs={1.5} sm={1} md={1}>
              <Typography className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse">
                Loc
              </Typography>
            </Grid>

            <Grid item xs={4} sm={4} md={4} lg={5}>
              <Typography className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse">
                {item?.LocName}
              </Typography>
            </Grid>

            <Grid item xs={12} className="text-center">
              <Typography className="CardFontStyleValue CardFontStyle">
                {item?.PartyName}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
